// extracted by mini-css-extract-plugin
export default {"ProjectsPage":"ProjectsPage_ProjectsPage__AoVLw","pageRow":"ProjectsPage_pageRow__ar08y"};